import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'María G.',
  text: 'Me encanta porque tengo TODO organizado. Antes perdía tiempo buscando mis herramientas, ahora todo está en su lugar.',
  photo: 'https://randomuser.me/api/portraits/women/44.jpg'
}, {
  name: 'Daniela R.',
  text: 'La calidad es increíble. Se siente premium desde que lo tocas.',
  photo: 'https://randomuser.me/api/portraits/women/68.jpg'
}, {
  name: 'Andrea P.',
  text: 'Lo llevo a todos lados. Trabajo, viajes, citas… es demasiado práctico.',
  photo: 'https://randomuser.me/api/portraits/women/65.jpg'
}, {
  name: 'Karla M.',
  text: 'Mis clientas notan la diferencia. Me veo mucho más profesional.',
  photo: 'https://randomuser.me/api/portraits/women/50.jpg'
}, {
  name: 'Valentina S.',
  text: 'No pensé que un kit hiciera tanta diferencia, pero sí… todo cambia cuando estás organizada.',
  photo: 'https://randomuser.me/api/portraits/women/47.jpg'
}, {
  name: 'Sofía L.',
  text: 'El diseño es hermoso y elegante. Me encanta sacar esto frente a mis clientas.',
  photo: 'https://randomuser.me/api/portraits/women/21.jpg'
}, {
  name: 'Camila T.',
  text: 'Todo viene bien protegido. Se nota que pensaron en cada detalle.',
  photo: 'https://randomuser.me/api/portraits/women/33.jpg'
}, {
  name: 'Laura C.',
  text: 'Perfecto para principiantes y también para profesionales. Vale totalmente la pena.',
  photo: 'https://randomuser.me/api/portraits/women/57.jpg'
}, {
  name: 'Natalia F.',
  text: 'Lo compré para mí y terminé comprando otro para regalar.',
  photo: 'https://randomuser.me/api/portraits/women/90.jpg'
}, {
  name: 'Jessica V.',
  text: 'Compacto pero súper completo. No ocupa espacio y tiene todo.',
  photo: 'https://randomuser.me/api/portraits/women/75.jpg'
}, {
  name: 'Paola E.',
  text: 'Desde que lo uso trabajo más rápido y organizada.',
  photo: 'https://randomuser.me/api/portraits/women/82.jpg'
}, {
  name: 'Mariana D.',
  text: 'Se ve elegante, se siente premium y funciona perfecto.',
  photo: 'https://randomuser.me/api/portraits/women/26.jpg'
}];
export function Testimonials() {
  return <section className="py-24 px-6 bg-nude-light" data-id="element-300">
      <div className="max-w-6xl mx-auto" data-id="element-301">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif text-3xl sm:text-4xl text-luxury-black text-center mb-16" data-id="element-302">
          LO QUE DICEN NUESTRAS CLIENTAS
        </motion.h2>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-303">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.06
        }} className="bg-white rounded-2xl p-5 sm:p-6 shadow-sm border border-rosado-light/20 flex flex-col items-center text-center" data-id="element-304">
              <img src={t.photo} alt={t.name} loading="lazy" decoding="async" className="w-12 h-12 sm:w-14 sm:h-14 rounded-full object-cover mb-3 ring-2 ring-rosado-light/40" data-id="element-305" />
              <div className="flex gap-0.5 mb-2" data-id="element-306">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 sm:w-4 sm:h-4 fill-gold text-gold" data-id="element-307" />)}
              </div>
              <p className="text-sm sm:text-base text-luxury-dark leading-relaxed mb-3 italic" data-id="element-308">
                "{t.text}"
              </p>
              <span className="text-xs sm:text-sm font-semibold text-luxury-black tracking-wide" data-id="element-309">
                — {t.name}
              </span>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-center mt-14 text-lg sm:text-xl text-luxury-black font-serif" data-id="element-310">
          ✨ Más de 100 mujeres ya confían en este kit
        </motion.p>
      </div>
    </section>;
}